
    <select class="form-control" id="sort" (change)="sort($event)">
        <!-- <option value="" selected disabled>{{sortName}}</option> -->
        <option *ngFor="let item of sortData" [value]="item.key" >{{item.value}}</option>
  
  
      </select>
  